import cssVariables from 'tfs.css-variables'

export default {
  title: {
    fontSize: '1.25rem',
    margin: '0 0 0.5rem',
    color: cssVariables.colorBlue,
  },
  header: {
    textAlign: 'left',
    paddingBottom: '1.75rem',
    color: cssVariables.colorBlue,
  },
}
